import React, {  useEffect, useState } from "react";
import styled from "styled-components";
import MarketingServices from "../../based/services/MarketingServices";
import Common from "../../based/Common";
import { Modal } from "react-bootstrap";

const ModalSpinChangeApplyDate = ({isShow , onClose , spinPrizeId , dataApply , date}) => {
    const [specialDay , setSpecialDay] = useState([])
    const [data, setData] = useState(dataApply)

    useEffect(() => {
        setData(dataApply)
    },[dataApply])
    
    useEffect(()=>{
        if(spinPrizeId > 0)
        getSpecialDayByGiftId(spinPrizeId)
    },[spinPrizeId, isShow])
    
    const getSpecialDayByGiftId = async (spinPrizeId) => {
        let [err , data ] = await MarketingServices.GetSpecialDayBySpinPrizeId(spinPrizeId);
        if(!err && data){
            setSpecialDay(data)
        }else{  
            setSpecialDay([])
        }
    }

    const CreateSpecApply = async (date , id) =>{
        let [err , data ] = await MarketingServices.CreateSpinSpecialDayApply({
            id: 0,
            spinSpecialDayId: id,
            applyDate: date
        });
        if(!err && data){
          
            setData({
                id: 0,
                spinSpecialDayId: id,
                applyDate: date
            })
            
        }else{

        }
    }

    const deleteSpinSpecialDayApply = async (date , id) =>{
        let [err , data ] = await MarketingServices.DeleteSpinSpecialDayApply({
            id: 0,
            spinSpecialDayId: id,
            applyDate: date
        });
        if(!err && data){
            setData({})
        }else{

        }
    }

    return (
        <Modal show={isShow} onHide={onClose} size={'md'} id={Common.generateGuid()} enforceFocus={false}
        scrollable={true} style={{ maxHeight: "90vh", overflow: "auto" }}>
             <Modal.Header>
                <button type='button' className='close' onClick={onClose}>
                    <span aria-hidden='true'>×</span>
                    <span className='sr-only'>Close</span>
                </button>
                <Modal.Title>Chọn ngày đặc biệt</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ModalSpinChangeApplyDateStyle 
                    
                    className={`partner_modal `} >
                   

                    <div className="partner_modal_body">
                        {specialDay.length > 0 && specialDay.map((item , idx)=>{
                            return <div className="item-day-special">
                                <input type="radio" id={`radio-${idx}`} checked={data && item.id == data.spinSpecialDayId}
                                    onClick={()=>{
                                        if(data && data.spinSpecialDayId)
                                            deleteSpinSpecialDayApply(data.applyDate,data.spinSpecialDayId)
                                        CreateSpecApply(date,item.id)

                                    }}
                                />
                                <label for={`radio-${idx}`}>{specialDay.length - idx} - {item.name}</label>
                            </div>
                        })}
                    </div>
                    
                </ModalSpinChangeApplyDateStyle>
            </Modal.Body>
            <Modal.Footer>
                <div style={{ width: '100%' }}>
                    <div className="box-button" style={{ display: "flex", justifyContent: 'center' }}>
                        <button className="btn-danger" onClick={()=>{onClose()}}>Đóng</button>
                        {data && data.spinSpecialDayId &&
                            <button className="ml-3 btn-custom"
                            onClick={()=>{
                                deleteSpinSpecialDayApply(data.applyDate,data.spinSpecialDayId)
                            }}
                            >Bỏ chọn</button> }
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

const ModalSpinChangeApplyDateStyle = styled.div`
    width: 100%;
    bottom: 0;
    height: 270px;
    border-radius: 16px 16px 0 0 !important;
    position: relative;
    background-color: #fff !important;
    font-family: 'Lexend';

    @media (min-width: 768px) {
        max-width: 350px;
        border-radius: 16px !important;
        overflow: hidden;

        
    }



    .partner_modal_body{
        padding-bottom: 80px;
        margin-top: 10px;

        .item-day-special{
            display: flex;
            align-items: center;
            margin-top: 10px;
            input{
                width: 24px;
                height: 24px;
                accent-color: #4d9b65;
            }
            label{
                color: #505050;
                font-family: Lexend;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 1;
                margin: 0 0 0 20px;
            }
        }

    }

    .box-footer-modal{
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 0;
        background-color: #fff;
        height: 60px;

    
        .partner_modal_body-comfirm-btn{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 60px;
            padding: 0 16px;
            z-index: 1;
            background-color: #fff;
    
            button{
                border: none;
                outline: none;
                border-radius: 10px;
                width: 125px;
                height: 38px;
                color: #FFF;
                font-size: 14px;
                font-weight: 600;
                line-height: 38px;
                text-align: center;
                border: 2px solid #f4f4f4;
                color: #B3282D;
                background-color: #fff;
                line-height: 1;
                margin: 0 5px;
               
    
                &.accept{
                    background: #B3282D;
                    color: #fff;
                }
            }
    
        }
    }
    
    


    

    
`

export default ModalSpinChangeApplyDate

